<div class="payment-success-container w-100">
  <div class="close-modal" (click)="closeModal()"><span>X</span></div>
  <div class="payment-success">
    <div class="icon">
      <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.4997 0.333008C10.5397 0.333008 0.833008 10.0397 0.833008 21.9997C0.833008 33.9597 10.5397 43.6663 22.4997 43.6663C34.4597 43.6663 44.1663 33.9597 44.1663 21.9997C44.1663 10.0397 34.4597 0.333008 22.4997 0.333008ZM16.628 31.2947L8.84967 23.5163C8.00467 22.6713 8.00467 21.3063 8.84967 20.4613C9.69467 19.6163 11.0597 19.6163 11.9047 20.4613L18.1663 26.7013L33.073 11.7947C33.918 10.9497 35.283 10.9497 36.128 11.7947C36.973 12.6397 36.973 14.0047 36.128 14.8497L19.683 31.2947C18.8597 32.1397 17.473 32.1397 16.628 31.2947Z"
          fill="#39A84A"/>
      </svg>
    </div>
    <div class="title mt-3">
      <ng-container *ngIf="!isDateProgrammed; else programmed">
        {{translations?.exito}}
      </ng-container>
      <ng-template #programmed>
        {{translations?.pago_programado}}
      </ng-template>
    </div>
    <div class="date-payment mt-3">
      {{translations?.fecha_de_operacion}}: {{today}}
    </div>
  </div>
  <div class="separator">

  </div>
  <div class="payment-success-detail mt-2">
    <div class="amount p-2">
      <p class="subtitle">{{translations?.importe}}</p>
      <p class="value">{{paymentSuccessModel.symbol}} {{amountsUtilsService.getFormatNumbers(paymentSuccessModel.amount)}} {{paymentSuccessModel.currency}}</p>
    </div>
    <div class="commission p-2 layout">
      <p class="subtitle">{{translations?.comision}}</p>
      <p class="value">{{paymentSuccessModel.symbol}} {{amountsUtilsService.getFormatNumbers(paymentSuccessModel.commission)}} {{paymentSuccessModel.currency}}</p>
    </div>
    <div class="receiver p-2">
      <p class="subtitle">{{translations?.destinatario}}</p>
      <p class="value">{{paymentSuccessModel.receiver}}</p>
    </div>
    <div class="bank p-2 layout">
      <p class="subtitle">{{translations?.banco}}</p>
      <p class="value">{{paymentSuccessModel.bank}}</p>
    </div>
    <div class="concept p-2 ">
      <p class="subtitle">{{translations?.cuenta}}</p>
      <p class="value">{{paymentSuccessModel.account}}</p>
    </div>
    <div class="concept p-2 layout">
      <p class="subtitle">{{translations?.Info}}</p>
      <p class="value">{{paymentSuccessModel.receiverInformation}}</p>
    </div>
  </div>


  <div
    class="download-pdf mt-4"
    (click)="downloadPdf()"
  >
    <div class="icon">
      <ng-container *ngIf="!loading; else loadingSpinner">
        <svg  width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.166992 14.6667H11.8337V13H0.166992V14.6667ZM11.8337 5.5H8.50033V0.5H3.50033V5.5H0.166992L6.00033 11.3333L11.8337 5.5Z"
            fill="#0098DD"/>
        </svg>
      </ng-container>
      <ng-template #loadingSpinner>
        <i class="pi pi-spin pi-spinner ms-1" style="font-size: 1rem"></i>
      </ng-template>
    </div>
    <div class="label ms-2">
      {{!loading ? translations?.comprobante : translations?.downloadingMessage}}
    </div>
  </div>
</div>
